
















import Vue from "vue";

  const key= "IUt+ajJnM0s/LlJeYVJqPX4kYHQ="
  const saltkey: Uint8Array = new Uint8Array([115,254,73,245,128,46,70,153,186,249,214,205,114,144,136,34])
  const wrapppedkey: Uint8Array = new Uint8Array([227,205,119,193,117,37,56,121,52,103,207,251,121,24,199,51,29,225,179,0,88,176,157,12,76,99,242,75,12,4,176,78,110,215,192,202,240,241,182,42,141,161,42,6,153,76,66,13,55,76,149,227,29,136,40,241,240,25,133,97,247,111,144,60,14,231,154,92,224,50,163,140,48,152,150,148,182,57,105,196,166,145,113,202,102,133,83,29,204,203,225,30,175,103,2,185,73,88,250,226,10,177,90,59,200,243,231,122,136,167,68,31,154,66,92,242,98,211,212,95,182,169,102,200,117,105,168,145,122,97,30,173,200,83,10,220,168,176,23,222,154,58,122,209,123,186,244,132,58,157,244,197,252,234,188,86,135,55,181,176,128,223,101,23,232,67,179,39,215,179,211,6,198,161,22,232,75,98,122,101,84,32,3,148,234,16,69,95,86,49,161,136,46,133,219,108,0,190,156,181,98,199,120,253,0,100,10,65,243,13,131,43,53,53,112,50,94,144,254,122,146,237,252,211,195,57,136,53,161,232])
  const ivkey: Uint8Array = new Uint8Array([58,224,183,31,201,168,56,74,5,203,39,46])

  const texenc = new TextEncoder()


  function getKeyMaterial() {

  return crypto.subtle.importKey(
    "raw",
    texenc.encode(atob(key)),
    {name: "PBKDF2"},
    false,
    ["deriveBits", "deriveKey"]
  );
}

 function getKey(keyMaterial: CryptoKey, salt: Uint8Array) {
    return crypto.subtle.deriveKey(
      {
        "name": "PBKDF2",
        salt: salt, 
        "iterations": 100000,
        "hash": "SHA-256"
      },
      keyMaterial,
      { "name": "AES-GCM", "length": 256},
      true,
      [ "wrapKey", "unwrapKey" ]
    );
  }


const init = function()
{
  getKeyMaterial().then((keyMaterial)=>
  {
    getKey(keyMaterial, saltkey).then((derivedkey)=>{
      crypto.subtle.unwrapKey(
                          "jwk",
                          wrapppedkey.buffer,
                          derivedkey,
                          {name:"AES-GCM", iv:ivkey},
                          {name: "ECDSA", namedCurve: "P-384", hash: {name: "SHA-384"}},
                          true,
                          ["verify"]
                        ).then((verifykey)=>{this.publickeyimported=verifykey;});
    })
  });
}

const VerifySignature = function(this: any)
{
    
  // Conversion 
  const signatureraw = (document.getElementById("signature") as HTMLInputElement).value.split(',')

  const signatureUInt8 = new Uint8Array(new ArrayBuffer(signatureraw.length * 1));
  signatureUInt8.forEach((_, i) => {
    signatureUInt8[i] = parseInt(signatureraw[i]);
  });

  crypto.subtle.verify(
    {name: "ECDSA",hash: {name: "SHA-384"}},
    this.publickeyimported,
    signatureUInt8,
    texenc.encode((document.getElementById("message") as HTMLInputElement).value)
  ).then((result: boolean)=>
  {
    //console.log(this.publickeyimported)
    (document.getElementById("result") as HTMLElement).innerText = "Result: " + result;
  })
}

export default Vue.extend(
  {
    name: "VerifySignature",
    data : function() { return { publickeyimported: CryptoKey } },
    beforeCreate: init,
    methods: { VerifySignature }
  }
)


